<div class="watch">
  <img
    [routerLink]="'/dashboard'"
    class="watch__img"
    src="assets/img/logo_blanco_1024.png"
    alt=""
  />
  <span class="watch__hour"> {{ time | date : "HH:mm:ss" }} </span>
</div>
